export default __webpack_public_path__ + "static/Experimentation-Over-Elaborate-Planning-d6ae177908fb4542404242392534140d.webp";